<template>
  <div>
    <!-- page-wrapper Start-->
    <div class="loader-wrapper loderhide" v-if="loading">
      <div class="loader-index">
        <span></span>
      </div>
    </div>
    <div v-else class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo pt-0">
                  <img
                    class="img-fluid for-light"
                    :src="logo"
                    style="max-width:250px"
                    alt="looginpage"
                  />
                  <img
                    class="img-fluid for-dark"
                    :src="logo"
                    style="max-width:250px"
                    alt="looginpage"
                  />
                </a>
              </div>
              <div class="login-main">
                <b-card>
                  <b-card-text>
                        <form class="theme-form" @submit.prevent="handleRegister">
                          <h4>{{ $t('registrasi') }}</h4>
                          <p>{{ $t('deskripsi_register') }}</p>
                          <div class="form-group">
                            <label for="username">Name <span style="color:red;">*</span></label>
                            <input
                              type="text"
                              v-model="form.fullname"
                              name="fullname"
                              class="form-control"
                              :class="{ 'is-invalid': submitted && !form.fullname }"
                            />
                            <div
                              v-show="submitted && !form.fullname"
                              class="invalid-feedback"
                            >
                              Fullname is required
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="username">Corporate Email Address <span style="color:red;">*</span></label>
                            <input
                              type="email"
                              v-model="form.email"
                              name="email"
                              class="form-control"
                              :class="{ 'is-invalid': submitted && !form.email }"
                            />
                            <div
                              v-show="submitted && !form.email"
                              class="invalid-feedback"
                            >
                              Email is required
                            </div>
                          </div>
                          <div class="form-group">
                            <label htmlFor="password">Password <span style="color:red;">*</span></label>
                            <input
                              type="password"
                              v-model="form.password"
                              name="password"
                              class="form-control"
                              :class="{
                                'is-invalid': submitted && !form.password,
                              }"
                            />
                            <div
                              v-show="submitted && !form.password"
                              class="invalid-feedback"
                            >
                              Password is required
                            </div>
                          </div>
                          <div class="form-group mt-3 mb-0">
                            <button
                              class="btn btn-primary btn-block"
                              :disabled="loggingIn"
                            >
                              Register
                            </button>
                          </div>
                          <p class="mt-4 mb-0">
                            {{ $t('sudah_punya_akun') }} ?
                            <router-link
                              class="ml-2"
                              tag="a"
                              to="/auth/login"
                            >
                              Login
                            </router-link>
                          </p>
                        </form>
                      </b-card-text>
                </b-card>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- latest jquery-->
  </div>
</template>
<script>
  export default {
    data(){
      return {
        logo : localStorage.getItem('logo'),
        form: {
          password : '',
          email : '',
          fullname : ''
        },
        numberOptions:[
          { value:'Other' , text: 'Other' },
        ],
        submitted: false,
        loading: true
      };
    },
    computed:{
      loggingIn() {
        return this.$store.state.authentication.status.loggingIn;
      },
    },
    created(){
      this.getColor();
    },
    methods: {
      handleRegister(){
        this.submitted = true;
        if ( this.form.password && this.form.email && this.form.fullname) {
          this.$store.dispatch('authentication/registrasi', this.form).then(res => {
          if (res.code != 500) {
            this.$notify({
              group: 'toast',
              type: 'warning',
              text: this.$t('registrasi_guide'),
              time: 5000
            });
            this.$router.push({
              path: "auth/login"
            });
          }else{
            this.$notify({
              group: 'toast',
              type: 'warning',
              text: res.data.error
            });
          }
        });
        }

      },
      async getColor(){
        await this.$store.dispatch('match_scoring/getColor', {
          code: process.env.VUE_APP_CODE
        }).then(res => {
          let data = res.data;
          let primary = data.primary_color;
          let secondary = data.secondray_color;
          this.$store.dispatch('layout/setColorScheme', { primary, secondary });
          localStorage.setItem('logo', data.logo_url);
          if (!localStorage.getItem('currentLanguage')) {
            localStorage.setItem('currentLanguage', data.language);
            window.location.reload();
          }
          this.logo = data.logo_url;
          this.loading = false;
        });


      },
      toshButton(){
        this.$notify({
          group: 'toast',
          type: 'success',
          text: 'Berhasil Notif'
        });
      }
    }
  };
</script>
